// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-education-js": () => import("./../../../src/pages/education.js" /* webpackChunkName: "component---src-pages-education-js" */),
  "component---src-pages-education-payment-status-js": () => import("./../../../src/pages/education/paymentStatus.js" /* webpackChunkName: "component---src-pages-education-payment-status-js" */),
  "component---src-pages-education-register-js": () => import("./../../../src/pages/education/register.js" /* webpackChunkName: "component---src-pages-education-register-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

